import type { CSSProperties, ReactNode } from 'react';

/** 本文 16px 基準: 英字ラベルも同サイズ */
export const SECTION_LABEL_FONT_SIZE = '16px';

const INTER = '"Inter", sans-serif';
const TITLE_FONT = '"Inter", "Helvetica Neue", sans-serif';

type Tone = 'light' | 'dark' | 'accent' | 'lightAccent';

const toneStyles: Record<Tone, { label: string; title: string; line: string }> = {
  light: { label: '#6B7280', title: '#111111', line: '#E5E7EB' },
  dark: { label: '#FFFFFF', title: '#FFFFFF', line: 'rgba(255,255,255,0.75)' },
  accent: { label: '#B48C50', title: '#FFFFFF', line: 'rgba(255,255,255,0.75)' },
  lightAccent: { label: '#B48C50', title: '#111111', line: '#E5E7EB' },
};

const sizeStyles = {
  page: 'clamp(36px, 6vw, 72px)',
  section: 'clamp(32px, 4vw, 48px)',
  subsection: 'clamp(28px, 4vw, 44px)',
} as const;

export type SectionHeadingProps = {
  label: string;
  title?: ReactNode;
  as?: 'h1' | 'h2' | 'h3';
  tone?: Tone;
  size?: keyof typeof sizeStyles;
  className?: string;
  titleClassName?: string;
  titleStyle?: CSSProperties;
};

/** 英字ラベル → 短い区切り線 → 和文見出し（縦並び） */
export default function SectionHeading({
  label,
  title,
  as: Tag = 'h2',
  tone = 'light',
  size = 'section',
  className = '',
  titleClassName = '',
  titleStyle,
}: SectionHeadingProps) {
  const colors = toneStyles[tone];

  return (
    <div className={className}>
      <span
        className="block font-medium tracking-widest"
        style={{
          fontSize: SECTION_LABEL_FONT_SIZE,
          color: colors.label,
          fontFamily: INTER,
        }}
      >
        {label}
      </span>
      <div className="mt-3 h-px w-8" style={{ background: colors.line }} aria-hidden />
      {title != null && title !== '' ? (
        <Tag
          className={`mt-4 font-black leading-tight ${titleClassName}`}
          style={{
            fontSize: sizeStyles[size],
            color: colors.title,
            fontFamily: TITLE_FONT,
            letterSpacing: size === 'page' ? '-0.03em' : '-0.02em',
            ...titleStyle,
          }}
        >
          {title}
        </Tag>
      ) : null}
    </div>
  );
}
